<main class="main">
  <div class="main-content">
    <h1 class="title">
      Événement gratuit - L'Étincelle du mois
    </h1>

    <div class="image relative">
      <img [src]="`assets/event.jpg`">
    </div>

    <div class="content">

      <section class="section">
        <h3>Ton profil te donne une idée de la situation mais tu fais quoi maintenant pour débloquer ta relation ?</h3>
        <p>
          Pour passer de la théorie à la pratique, je t'invite à en discuter de vive voix le <strong>03 mars à
          20h15</strong> sur Google
          Meet.
        </p>
        <p class="text-center mt-4">
          <a
            pButton
            label="Inscris-toi gratuitement"
            href="https://docs.google.com/forms/d/e/1FAIpQLSdXK2dTBfj-n2oXe_9Qvgw5aYZNcVkCR6Gemzji5tbQ9WnUeQ/viewform?usp=send_form"
            target="_blank"></a>
        </p>
      </section>
      <app-accent title="🎁 Mon cadeau">
        Parce que nos blocages viennent souvent de nos "blessures", j'offrirai en direct à tous les participant(e)s mon
        livret inédit pour comprendre ce qui coince et donner les clés indispensables pour transformer sa relation.

      </app-accent>
      <section class="section">
        <p class="text-center">
          Envie d'en savoir plus sur Lumenité Étoilée en attendant ?
          <a
            pButton
            class="p-button-outlined"
            label="Découvre mon univers !"
            href="https://lumeniteetoilee.oztamu.fr/"
            target="_blank"></a>
        </p>
      </section>
    </div>
    <div class="action">
      <p-button
        icon="pi pi-refresh"
        label="Refaire le quiz"
        severity="secondary"
        [routerLink]="''"
        aria-label="Accueil">
      </p-button>
    </div>
  </div>
</main>
